import { Component, OnDestroy } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ClickEvent } from "devextreme/ui/button";
import { ToolbarItem } from "devextreme/ui/data_grid";
import { MetadataService } from "src/app/services/metadata.service";
import { ToolbarItemFactory } from "src/app/shared/toolbar";

@Component({
  selector: "brd-functionalities-form",
  templateUrl: "./functionalities-form.component.html",
  styleUrl: "./functionalities-form.component.less",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FunctionalitiesFormComponent,
      multi: true
    }
  ],
  standalone: false
})
export class FunctionalitiesFormComponent implements ControlValueAccessor, OnDestroy {
  selectedFunctionalities: number[];
  onChange!: (arg0: number[]) => void;
  onTouched!: () => void;
  disabled = false;
  filterActive = false;

  customToolbarItems: ToolbarItem[] = [
    ToolbarItemFactory.createButton({
      location: "after",
      text: "Show only selected",
      onClick: (event: ClickEvent) => {
        this.metadataService.setFilterFunctionalities(this.filterActive ? undefined : this.selectedFunctionalities);
        event.component.option("text", this.filterActive ? "Show only selected" : "Show all");

        this.filterActive = !this.filterActive;
      }
    })
  ];

  constructor(private metadataService: MetadataService) {}

  ngOnDestroy(): void {
    this.metadataService.setFilterFunctionalities(undefined);
  }

  writeValue(value: number[]): void {
    this.selectedFunctionalities = value;
  }
  registerOnChange(fn: (arg0: number[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectionChanged(values: number[]): void {
    this.selectedFunctionalities = values;
    this.onChange(values);
    this.onTouched();
  }
}
